import moment from "moment";
import { poNumberFormate } from "jsFunctions/helperFunctions";
import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";
import { poMonthFormate } from "jsFunctions/helperFunctions";


const categoryMap = {
    ExternalExpense: 'External Expense',
    InternalExpanse: 'Internal Expense',
    ResourceExpense: 'Resource Expense'
  };

export const getVendorGstExcelData = (vendorList) => {
    let list = JSON.parse(JSON.stringify(vendorList));
    const exportData = list.map((data, index) => {
      let content = {
        no: index + 1,
        "Order PO Number": data.poNo && poNumberFormate(data?.expenseId?.poNo),
        "Current Order Date": data.oDt && moment(data.oDt).format("DD-MMM-YYYY"),

        "Base Amount":`₹ ${data?.bsAmt  ? formatAmountIndianRupees(parseFloat(data?.bsAmt)) : Number(0).toFixed(2)}`,
        "IGST Amount" : `₹ ${data?.amt?.i  ? formatAmountIndianRupees(parseFloat(data?.amt?.i)) : Number(0).toFixed(2)}`,
        "CGST Amount" : `₹ ${data?.amt?.c  ? formatAmountIndianRupees(parseFloat(data?.amt?.c)) : Number(0).toFixed(2)}`,
        "SGST Amount" : `₹ ${data?.amt?.s  ? formatAmountIndianRupees(parseFloat(data?.amt?.s)) : Number(0).toFixed(2)}`


    };
   
      

      return content;
    });
    return exportData;
  };